var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcError16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00098 2.87988C8.17101 2.87995 8.33788 2.92539 8.48438 3.01172C8.6309 3.0981 8.75158 3.2223 8.83398 3.37109L8.83496 3.37207L13.4648 11.707C13.5454 11.8521 13.5861 12.0157 13.584 12.1816C13.5818 12.3476 13.5364 12.5103 13.4521 12.6533C13.3678 12.7963 13.2477 12.9148 13.1035 12.9971C12.9593 13.0793 12.7959 13.1223 12.6299 13.1221H3.36914C3.20339 13.122 3.04037 13.0794 2.89648 12.9971C2.75247 12.9147 2.63296 12.7953 2.54883 12.6523C2.46479 12.5094 2.41909 12.3474 2.41699 12.1816C2.41493 12.0157 2.45656 11.8521 2.53711 11.707L7.16602 3.37207L7.16699 3.37109C7.2494 3.22226 7.37005 3.09812 7.5166 3.01172C7.66324 2.92526 7.83075 2.87988 8.00098 2.87988Z",
    stroke: "#FF0700",
    strokeWidth: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.28906L8 9.2878",
    stroke: "#FF0700",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.707H7.99603",
    stroke: "#FF0700",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError16);
export default __webpack_public_path__ + "static/media/ic_error_16.0dec6a2465019b93cbb5b1714c61b188.svg";
export { ForwardRef as ReactComponent };